module.exports = __webpack_public_path__ + "mp.svg?d4c8612c389a887d815b3980f23370f1";